import angular from 'angular';
import SplitViewPageComponent from './split-view-page.component';

const SplitViewPageModule = angular
    .module('control-room.commons.layout.components.split-view-page', [])
    .component('crSplitViewPage', SplitViewPageComponent);

export default SplitViewPageModule;
